'use strict';

import Script from 'next/script';

const PardotAnalyticsBase = () => {
  return (
    <Script id="pardot-analytics-script">
      {`
  piAId = '31352';
  piCId = '30828';
  (function () {
    function async_load() {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src =
        ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') +
        '.pardot.com/pd.js';
      var c = document.getElementsByTagName('script')[0];
      c.parentNode.insertBefore(s, c);
    }
    if (window.attachEvent) {
      window.attachEvent('onload', async_load);
    } else {
      window.addEventListener('load', async_load, false);
    }
  })();`}
    </Script>
  );
};

module.exports = PardotAnalyticsBase;
